import React from "react";

type ExportIconProps = {
  color?: string;
};

export const ExportIcon = ({ color = "#7515ed" }: ExportIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      d="M1 9.75V16.75C1 17.2141 1.18437 17.6592 1.51256 17.9874C1.84075 18.3156 2.28587 18.5 2.75 18.5H13.25C13.7141 18.5 14.1592 18.3156 14.4874 17.9874C14.8156 17.6592 15 17.2141 15 16.75V9.75M11.5 4.5L8 1M8 1L4.5 4.5M8 1V12.375"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);